import { CartType } from "interfaces";
import { createSlice } from "@reduxjs/toolkit";

type CartsType = {
  isCartOpen: boolean;
  shopId: number;
  list: {
    stockId: number;
    quantity: number;
    cartDetailId?: number;
  }[];
  cart: CartType;
};

const initialState: CartsType = {
  isCartOpen: false,
  shopId: 0,
  list: [],
  cart: {
    id: 0,
    shop_id: 0,
    total_price: 0,
    user_carts: [
      {
        id: 0,
        name: "",
        user_id: 1,
        uuid: "",
        cartDetails: [],
      },
    ],
  },
};

const cartsSlice = createSlice({
  name: "carts",
  initialState,
  reducers: {
    setShopId: (state, action) => {
      state.shopId = action.payload;
    },
    addProduct: (state, action) => {
      state.list = [...state.list, action.payload];
    },
    increment: (state, action) => {
      const { payload } = action;
      state.list = state.list.map((item) => {
        if (item.stockId === payload.stockId) {
          return {
            ...item,
            quantity: item.quantity + payload.quantity,
          };
        }
        return item;
      });
    },
    decrement: (state, action) => {
      const { payload } = action;
      state.list = state.list.map((item) => {
        if (item.stockId === payload.stockId) {
          return {
            ...item,
            quantity: item.quantity - payload.quantity,
          };
        }
        return item;
      });
    },
    setQuantity: (state, action) => {
      const { payload } = action;
      state.list = state.list.map((item) => {
        if (item.stockId === payload.stockId) {
          return {
            ...item,
            quantity: payload.quantity,
          };
        }
        return item;
      });
    },
    updateProduct: (state, action) => {
      const { payload } = action;
      state.list = state.list.map((item) => {
        if (item.stockId === payload.stockId) {
          return {
            ...item,
            ...payload,
          };
        }
        return item;
      });
    },
    deleteProduct: (state, action) => {
      state.list = state.list.filter(
        (item) => item.stockId !== action.payload.stockId,
      );
    },
    updateList: (state, action) => {
      state.list = action.payload;
    },
    updateCart: (state, action) => {
      state.cart = action.payload;
    },
    clearList: (state) => {
      state.list = initialState.list;
    },
    clearShopId: (state) => {
      state.shopId = initialState.shopId;
    },
    clearFullCart: (state) => {
      state.cart = initialState.cart;
      state.list = initialState.list;
      state.shopId = initialState.shopId;
    },
    toggleCartButton: (state) => {
      state.isCartOpen = !state.isCartOpen;
    },
  },
});

export const {
  setShopId,
  addProduct,
  increment,
  decrement,
  setQuantity,
  updateList,
  updateCart,
  clearList,
  deleteProduct,
  clearShopId,
  updateProduct,
  clearFullCart,
  toggleCartButton,
} = cartsSlice.actions;

export default cartsSlice.reducer;
